import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LGCandidate } from 'src/app/models/LGCandidate';
import { ApiDataService } from 'src/app/services/api-data.service';
import { LgElectionService } from 'src/app/services/lg-election.service';
import { LGEElectionStatusEnum } from 'src/app/enums/LGEElectionStatusEnum';
import { LGDocument } from 'src/app/models/LGDocument';
import { LGEResultsStatusEnum } from 'src/app/enums/LGEResultsStatusEnum';

@Component({
  selector: 'app-page-lge-results-phone',
  templateUrl: './page-lge-results-phone.component.html',
  styleUrls: ['./page-lge-results-phone.component.scss']
})
export class PageLgeResultsPhoneComponent implements OnInit {

  public LGEElectionStatusEnum = LGEElectionStatusEnum;
  public LGEResultsStatusEnum = LGEResultsStatusEnum;

  constructor(public lgElectionService: LgElectionService,
    private apiDataService: ApiDataService,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

  }


  public loadImageFromBlob(candidate: LGCandidate): void {
    if (candidate.candidatePhotoUrl && candidate.isImageLoaded === false) {
      this.apiDataService.getImageFromBlob$(candidate.candidatePhotoUrl).subscribe(response => {
        candidate.imageSource = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(response));
        candidate.isImageLoaded = true;
      });
    }
    else if (candidate.candidatePhotoUrl === null) {
      candidate.imageSource = 'assets/images/noPhoto.jpg';
      candidate.isImageLoaded = true;
    }
  }

  public openCandidate(candidate: LGCandidate): void {
    
  }

  public openDocument(document: LGDocument): void {
    this.apiDataService.downloadDocumentBlob$(document.documentUrl).subscribe(response => {
      const fileURL = URL.createObjectURL(response);
      window.open(fileURL, '_blank');
    });
  }
  
}
